module.exports = __webpack_public_path__ + "static/Invoice-System-1-cbd040a1cd8ce80a4405ca828dc1f268.png";